import { sha256 } from "js-sha256";

export const logMajorVersionMismatch = (): void => {
  const outdatedPackages: string | null =
    import.meta.env.VITE_OUTDATED_PACKAGES ?? null;
  if (!outdatedPackages || !isDevOrStagingEnvironment) return;

  const packageInfo: string[] = outdatedPackages.split(/\s+/);

  const packageName: string = packageInfo[0];
  const currentVersion: string = packageInfo[1];
  const latestVersion: string = packageInfo[3];

  if (currentVersion.split(".")[0] !== latestVersion.split(".")[0]) {
    console.warn("Outdated package with major version mismatch:");
    console.warn(`${packageName}: ${currentVersion} => ${latestVersion}`);
  }
};

export const anonymizeUsername = (username: string) => {
  return sha256(username);
};

export const isAiEnabled = () => import.meta.env.VITE_AI_ENABLED === "true";

export const isDevEnvironment = import.meta.env.VITE_ENV === "development";
export const isStagingEnvironment = import.meta.env.VITE_ENV === "staging";
export const isDevOrStagingEnvironment =
  isDevEnvironment || isStagingEnvironment;
